export default "__VITE_ASSET__DLv9meJF__"